"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { Link } from "react-router-dom";

export function JoinCommunityCta() {
  return (
    <section id="relume" className="relative px-[5%] py-16 md:py-24 lg:py-28 overflow-hidden">
      <div className="container relative">
        <div className="relative flex flex-col justify-center p-8 md:p-12 lg:p-16">
          <div>
            <div className="w-full max-w-lg">
              <h2 className="mb-5 text-5xl font-bold text-text-alternative md:mb-6 md:text-7xl lg:text-8xl">
                Join Our Storytelling Community
              </h2>
              <p className="text-text-alternative md:text-md">
                Dive deeper into our narratives and connect with fellow
                storytellers to share your passion.
              </p>
            </div>
            <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8">
              <Link to="/product" className="no-underline">
                <Button title="Explore" variant="primary">
                  Explore
                </Button>
              </Link>
              <Link to="/contact?type=product" className="no-underline">
                <Button title="Engage" variant="secondary-alt">
                  Engage
                </Button>
              </Link>
            </div>
          </div>
          <div className="absolute inset-0 -z-10">
            <img
              src="/assets/images/newsletter/background05.jpg"
              className="size-full object-cover"
              alt="Join Our Storytelling Community"
            />
            <div className="absolute inset-0 bg-black/50" />
            {/* Top gradient fade */}
            <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-[#0B1120] to-transparent" />
            {/* Bottom gradient fade */}
            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0B1120] to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}
